// extracted by mini-css-extract-plugin
export default {"label":"r8xRR","title":"_1UzNK","disabled":"_2R8yV"};